import { Component, OnInit } from '@angular/core';
import { TimerService } from '../../services/timer.service';
import { LanguagesService } from '../../services/language.service';
import { ConfigService } from '../../services/config.service';
import { BaseService } from '../../services/base.service';
declare var $: any;

@Component({
    selector: 'app-timeout-dialog',
    templateUrl: './timeout-dialog.component.html',
    styleUrls: ['./timeout-dialog.component.css']
})

export class TimeoutDialogComponent implements OnInit {

    isShowTimeOutDialog: boolean = false;
    theExit;
    lang: any = '1';
    currentLang: any;
    isRightToLeft: boolean;
    condition: boolean = false;
    officeWebsite: any;
    
    constructor(private timerService: TimerService, private languageService: LanguagesService, private configService: ConfigService, private base: BaseService) {
        this.officeWebsite = configService.getConfiguration().officeWebsite;
    }

    ngOnInit() {
        this.languageService.currentLanguage.subscribe(data => {
            this.lang = data;
            this.getGovLang();
        });
        this.timerService.timeoutExpired.subscribe(res => {
            this.isShowTimeOutDialog = true;
            if (this.isShowTimeOutDialog == true) {
                this.theExit = setTimeout(() => {
                    window.location.href = this.officeWebsite;
                }, 60000);
            }
        });
    }

    getGovLang() {
        if (this.lang === '1') {
            this.condition = false;
        }
        else {
            this.condition = true;
        }
   
        this.isRightToLeft = this.languageService.isRightToLeft;
    }

    cancel() {
        
        this.timerService.resetTimer();
        this.isShowTimeOutDialog = false;
        clearTimeout(this.theExit);
        this.base.checkIsExistsID(`0000`).toPromise();
    }

    exit() {
        
        this.timerService.stopTimer();
        window.location.href =this.officeWebsite;
      
    }
}
